import { Spinner } from '@heroui/react';
import type { FC } from 'react';

export interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  centered?: boolean;
  message?: string;
}

/**
 * LoadingSpinner component for displaying loading states
 *
 * @example
 * ```tsx
 * <LoadingSpinner size="lg" centered />
 * <LoadingSpinner message="Loading data..." />
 * ```
 */
export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 'lg', centered = true, message }) => {
  const spinner = <Spinner size={size} />;

  if (!centered && !message) {
    return spinner;
  }

  return (
    <div className={centered ? 'flex justify-center items-center py-12' : ''}>
      <div className="flex flex-col items-center gap-3">
        {spinner}
        {message && <p className="text-sm text-default-500">{message}</p>}
      </div>
    </div>
  );
};
